// Import model
import { StartEstimateAskSyntheaRequest } from '../models/StartEstimateAskSyntheaRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartEstimateAskSyntheaRequest - handles JSON serialization and deserialization with type validation
 */
export class StartEstimateAskSyntheaRequestSerializer {
  /**
   * Deserializes a JSON string into a StartEstimateAskSyntheaRequest instance
   */
  static deserialize(json: string): StartEstimateAskSyntheaRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartEstimateAskSyntheaRequest instance
   */
  static fromObject(obj: any): StartEstimateAskSyntheaRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartEstimateAskSyntheaRequest');
    }


    const instance: StartEstimateAskSyntheaRequest = {
      assistantId: obj['AssistantId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartEstimateAskSyntheaRequest instances
   */
  static deserializeArray(json: string): StartEstimateAskSyntheaRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartEstimateAskSyntheaRequest instance to a JSON string
   */
  static serialize(instance: StartEstimateAskSyntheaRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartEstimateAskSyntheaRequest instance to a plain object
   */
  static toObject(instance: StartEstimateAskSyntheaRequest): any {
    return {
      'AssistantId': instance.assistantId,
    };
  }

  /**
   * Serializes an array of StartEstimateAskSyntheaRequest instances to a JSON string
   */
  static serializeArray(instances: StartEstimateAskSyntheaRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
